module.exports = __webpack_public_path__ + "static/media/petal3.d30260b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinners/petal3.svg
// module id = 1696
// module chunks = 49